import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentMachineName: "",
    currentUserName: ""
  },
  mutations: {
    updateCurrentMachineName(state, name) {
      state.currentMachineName = name;
    },
    updateCurrentUserName(state, name) {
      state.currentUserName = name;
    }
  }
});
